import { SvgIcon, SvgIconProps } from '@mui/material';

const PageUnderDevelopment = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="173"
      height="137"
      viewBox="0 0 173 137"
      fill="none"
    >
      <path
        d="M2.25195 128.26V8.15903C2.25195 4.75749 5.00945 2 8.41098 2H163.926C167.328 2 170.085 4.75749 170.085 8.15903V128.26C170.085 131.662 167.328 134.419 163.926 134.419H8.41098C5.00944 134.419 2.25195 131.662 2.25195 128.26Z"
        stroke="#26262B"
        strokeWidth="4"
      />
      <path d="M2.25195 29.3306H170.085" stroke="#26262B" strokeWidth="4" />
      <circle
        cx="15.4748"
        cy="15.3369"
        r="2.13981"
        fill="#26262B"
        stroke="#26262B"
        strokeWidth="0.611374"
      />
      <circle
        cx="25.756"
        cy="15.3369"
        r="2.13981"
        fill="#26262B"
        stroke="#26262B"
        strokeWidth="0.611374"
      />
      <circle
        cx="36.0334"
        cy="15.3369"
        r="2.13981"
        fill="#26262B"
        stroke="#26262B"
        strokeWidth="0.611374"
      />
      <path
        d="M32.6613 114.402V113.034C32.6613 110.791 31.4417 108.725 29.4775 107.642L26.7226 106.122C23.8108 104.515 22.7002 100.887 24.2137 97.9258L27.841 90.8289C29.2701 88.0329 32.5737 86.7596 35.5096 87.8732L37.3556 88.5735C39.8385 89.5153 42.6455 88.7596 44.32 86.6986L44.5058 86.47C45.7682 84.9162 46.1967 82.8458 45.6547 80.9186L44.3045 76.1178C43.5637 73.4841 44.6491 70.6775 46.9692 69.2275L54.4795 64.5335C56.827 63.0663 59.865 63.3456 61.9056 65.2162L66.3977 69.334C67.2294 70.0963 68.3166 70.5192 69.4448 70.5192V70.5192C71.3858 70.5192 73.109 69.2772 73.7228 67.4359L76.2954 59.718C77.1337 57.203 79.4873 55.5066 82.1384 55.5066H90.0876C92.7914 55.5066 95.1791 57.2701 95.9743 59.8543L98.3306 67.5123C98.8805 69.2996 100.532 70.5192 102.402 70.5192V70.5192C103.356 70.5192 104.283 70.1987 105.033 69.609L111.122 64.8255C113.226 63.172 116.157 63.0668 118.375 64.5652L124.807 68.9114C127.197 70.526 128.146 73.5826 127.092 76.2668L125.818 79.5092C125.092 81.3567 125.301 83.4407 126.38 85.1072L126.796 85.7513C128.08 87.7355 130.386 88.81 132.731 88.5169L139.496 87.6714C142.312 87.3193 145.005 88.9377 146.015 91.5902L148.67 98.5587C149.708 101.285 148.692 104.366 146.234 105.939L143.668 107.581C141.899 108.713 140.829 110.669 140.829 112.769V114.402"
        stroke="#26262B"
        strokeWidth="4"
      />
      <path
        d="M113.114 114.402C113.114 111.369 112.408 108.366 111.034 105.564C109.661 102.761 107.647 100.215 105.11 98.0707C102.572 95.926 99.5587 94.2247 96.2428 93.064C92.9269 91.9033 89.3729 91.3059 85.7838 91.3059C82.1947 91.3059 78.6407 91.9033 75.3248 93.064C72.0089 94.2247 68.996 95.926 66.4581 98.0707C63.9202 100.215 61.907 102.761 60.5335 105.564C59.1601 108.366 58.4531 111.369 58.4531 114.402"
        stroke="#26262B"
        strokeWidth="4"
      />
    </svg>
  </SvgIcon>
);

export default PageUnderDevelopment;
